<template class="map-kind-page">
  <v-card>
    <ac-data-table
      ref="table"
      :headers="headers"
      :items="items"
      :item-class="classObj"
      item-key="uid"
      fixed-header
      :footer-props="footer"
      :items-per-page="50"
      :height="winsize.height - 145 - 48"

      :search.sync="search"
      v-model="selected"

      :can-select="item => !row_readonly(item)"
      :can-delete="item => !row_readonly(item)"
      :remove-bulk="bulkRemove"
      :bulk-mode.sync="bulkMode"

      title="Map Kind"
    >
      <template #actions>
        <v-btn @click="row_create" class="ma-2" color="primary">
          New Map Kind
        </v-btn>
        <v-btn @click="show_preview" class="ma-2" color="accent">
          Preview JSON
        </v-btn>
      </template>

      <template v-slot:item.group="{ item }">
        {{ item.group?.key || '' }}
      </template>

      <template v-slot:item.modifier="{ item }">
        {{ item.energyKindObj?.key || '' }}
      </template>

      <template v-slot:item.welcomeTile="{ item }">
        <span v-if="item.welcomeTile && (item.welcomeTile.x != null || item.welcomeTile.y != null)">
          x: {{ item.welcomeTile.x ?? 0 }}, y: {{ item.welcomeTile.y ?? 0 }}
        </span>
      </template>

      <template v-slot:item.maps="{ item }">
        <div>
          <v-tooltip
            v-if="item.maps?.length > 3"
            bottom
            content-class="map-kind-page__ttip"
          >
            <template v-slot:activator="{ on, attrs }">
              <span
                v-bind="attrs"
                v-on="on"
                class="map-kind-page__item-maps-coll"
                @click="copyMaps(item.maps)"
              >
                [Map Collection]
              </span>
            </template>
            <span>{{ item.maps.join(', ') }}</span>
          </v-tooltip>

          <span
            v-else
            class="map-kind-page__item-maps"
          >
            {{ item.maps?.join(', ') || '-' }}
          </span>
        </div>
      </template>

      <template v-slot:item.actions="{item}">
        <div style="white-space: nowrap">
          <v-icon v-if="row_readonly(item)" @click="row_view(item)" class="mr-2" small color="green">
            mdi-eye
          </v-icon>
          <v-icon v-else-if="item.locked" @click="row_update(item)" class="mr-2" small color="orange">
            mdi-pencil
          </v-icon>
          <v-icon v-else @click="row_update(item)" class="mr-2" small color="green">
            mdi-pencil
          </v-icon>
          <v-icon @click="row_copy(item)" class="mr-2" small color="teal lighten-1">
            mdi-content-copy
          </v-icon>
          <v-icon :disabled="item.global || item.shared" @click="row_export(item)" class="mr-2" small color="blue">mdi-briefcase-upload</v-icon>
          <v-icon :disabled="row_readonly(item)" @click="row_remove(item)" class="mr-2" small color="red">
            mdi-delete
          </v-icon>
        </div>
      </template>

      <template v-slot:no-results>
        <v-alert :value="true" color="blue-grey" dense>
          Your search for "{{ search }}" found no results.
        </v-alert>
      </template>
    </ac-data-table>

    <r-map-kind-dialog ref="dialog"/>
    <r-dialog-preview-collection ref="previewCollection"/>
  </v-card>
</template>

<script>
import {ViewRules} from "@/common/ViewRules";
import {RedactorUtils} from "@/modules/redactor/core/RedactorUtils";
import clsx from 'clsx';

import RMapKindDialog from "@/modules/redactor/views/map-kind/r-map-kind-dialog.vue";
import VueTypes from "vue-types";
import {MapKindModel} from "@/modules/redactor/models/map/MapKindModel";
import AcDataTable from "@/components/Table/ac-data-table.vue";
import RDialogPreviewCollection from "@/modules/redactor/views/preview/r-preview-collection-dialog.vue";


export default {
  name: "r-map-kind-page",
  components: {RDialogPreviewCollection, AcDataTable, RMapKindDialog},
  data: () => ({
    search: "",
    headers: [
      {text: "Key", value: "key"},
      {text: "Code", value: "code"},
      {text: "Group", value: "group"},
      {text: "Energy Kind", value: "energyKind"},
      {text: "Welcome Tile", value: "welcomeTile"},
      {text: "UID", value: "uid"},
      {text: '', value: 'actions', width: '100%', sortable: false, align: 'end'}
    ],

    items: {
      type: VueTypes.arrayOf(MapKindModel)
    },

    selected: [],
    bulkMode: false,

    footer: {
      "items-per-page-options": [10, 50, 100, -1]
    }
  }),
  computed: {
    masterAccess() {
      return RedactorUtils.hasMasterAccess();
    },
    winsize() {
      return window.app.winsize;
    }
  },
  methods: {
    classObj(item) {
      return clsx('map-kind-page__item', {
        'cyan lighten-4': item.global,
      });
    },

    copyMaps(maps) {
      if (!maps || maps.length <= 3) return;

      const text = maps.join(', ');

      navigator.clipboard.writeText(text)
        .then(() => {
          this.$alert?.("Copied to clipboard!") || console.log("Copied:", text);
        })
        .catch(err => {
          console.error("Clipboard copy failed:", err);
        });
    },

    row_view(item) {
      this.$refs['dialog'].show(ViewRules.READONLY, item.clone()).catch(() => {
      });
    },
    row_copy(item) {
      this.$refs['dialog'].show(ViewRules.COPY, item.copy()).then(
          result => {
            RedactorUtils.pushMapKind(result).then(
                () => {
                  this.$alert("Changes was published");
                });
          }, () => {
          });
    },
    row_create() {
      this.$refs['dialog'].show(ViewRules.CREATE, null).then(
          result => {
            RedactorUtils.pushMapKind(result).then(
                () => {
                  this.$alert("Changes was published");
                });
          }, () => {
          });
    },
    row_update(item) {
      this.$refs['dialog'].show(ViewRules.UPDATE, item.clone()).then(
          result => {
            RedactorUtils.pushMapKind(result).then(
                () => {
                  this.$alert("Changes was published");
                });
          }, () => {
          });
    },
    row_remove(item) {
      this.$confirm("Are you sure you want to delete this item?").then(() => {
        RedactorUtils.removeMapKind(item).then(
            () => {
              this.$alert("Changes was published");
            });
      });
    },

    bulkRemove(items) {
      return RedactorUtils.removeBulkMapKinds(items);
    },

    row_export(item) {
      let result = item.clone();
      result.export = !item.export;
      RedactorUtils.pushMapKind(result);
    },

    row_readonly(item) {
      return (item.locked && !this.masterAccess) || item.global || item.shared;
    },
    show_preview() {
      this.$refs['previewCollection'].show(this.items, MapKindModel, "map-kind")
          .then(() => this.$alert("Changes was published"));
    },
  },
  created() {
    this.items = RedactorUtils.getMapKinds();
  }
}
</script>

<style scoped lang="scss">
.map-kind-page {
  &__item {
    white-space: nowrap;

    &-maps {
      color: #424242;

      &-coll {
        color: #1976d2;
        text-decoration: underline dotted;
        white-space: nowrap;
        cursor: pointer;
      }
    }
  }

  &__ttip {
    background-color: #000;
    color: #fff;
  }
}

::v-deep .v-data-table thead th {
  white-space: nowrap;
}
</style>
